import React from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase";
import Tile from "../../types";
import { api } from "../../lib/api";

interface ImageTileProps {
  tile: Tile;
  setupMode?: boolean;
  updateTileConfig?: (id: string, config: Partial<Tile["config"]>) => void;
}

const ImageTile: React.FC<ImageTileProps> = ({ tile, setupMode, updateTileConfig }) => {
  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const storageRef = ref(storage, `tiles/${tile.id}/${file.name}`);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);

    // Update tile config locally
    updateTileConfig?.(tile.id, { imageUrl: downloadURL });

    // Update tile in backend (optional)
    await fetch(api.updateTile(tile.id), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ config: { imageUrl: downloadURL } }),
    });
  };

  return (
    <div className="flex flex-col items-center justify-center h-full space-y-2">
      {tile.config?.imageUrl ? (
        <img
          src={tile.config.imageUrl}
          alt="Tile"
          className="max-h-48 object-contain rounded shadow"
        />
      ) : (
        <div className="text-gray-500 italic">No image uploaded</div>
      )}
      {setupMode && (
        <input type="file" onChange={handleUpload} className="text-sm" />
      )}
    </div>
  );
};

export default ImageTile;
